export const AnniversaryData = {
  leaveid: null,
  parentid: null,
  leavetypeid: 10,
  leavecategoryid: 3,
  leavename: null,
  description: null,
  annualbalance: 0,
  monthlyallocate: [
    {
      monthid: 1,
      value: 0,
    },
    {
      monthid: 2,
      value: 0,
    },
    {
      monthid: 3,
      value: 0,
    },
    {
      monthid: 4,
      value: 0,
    },
    {
      monthid: 5,
      value: 0,
    },
    {
      monthid: 6,
      value: 0,
    },
    {
      monthid: 7,
      value: 0,
    },
    {
      monthid: 8,
      value: 0,
    },
    {
      monthid: 9,
      value: 0,
    },
    {
      monthid: 10,
      value: 0,
    },
    {
      monthid: 11,
      value: 0,
    },
    {
      monthid: 12,
      value: 0,
    },
  ],
  employeetypeids: null,
  maritalstatusids: null,
  creditmodetypeid: 0,
  daysbefore: 0,
  isallowhalfday: false,
  isallowedinprobation: false,
  accuralfrequencytype: 0,
  isfurtureappallowed: false,
  minleavecountforapp: 0,
  notifyinadvanceday: 0,
  notifynotbeforeday: 0,
  ispastappallowed: false,
  apppastday: 0,
  isleaveallowedinnotice: false,
  isclubbingallowed: false,
  clubbingleaveid: null,
  datastate: 1,
};
